import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Navbar from '../components/layout/Navbar';
import Footer from '../components/layout/Footer';

// Homepage Sub-components
import HeroSection from '../components/home/HeroSection';
import BestsellerSection from '../components/home/BestsellerSection';
import BenefitsSection from '../components/home/BenefitsSection';
import ProcessSection from '../components/home/ProcessSection';
import TestimonialsSection from '../components/home/TestimonialsSection';
import FAQSection from '../components/home/FAQSection';

import API from '../config/api';

const HomePage = () => {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchProducts = async () => {
      try {
        const response = await axios.get(`${API}/products`);
        const list = Array.isArray(response.data) ? response.data : (response.data?.products || []);
        setProducts(list);
      } catch (error) {
        console.error('Error fetching products for homepage:', error);
        setProducts([]);
      } finally {
        setLoading(false);
      }
    };

    fetchProducts();
  }, []);

  return (
    <div className="bg-[#FAF7F0] min-h-screen text-[#202522] selection:bg-[#173B32] selection:text-[#FAF7F0]">
      {/* 1. Header Navigation */}
      <Navbar />

      <main>
        {/* 2. Hero Section */}
        <HeroSection />

        {/* 3. Bestseller Picks (Real products from MongoDB) */}
        <BestsellerSection products={products} loading={loading} />

        {/* 4. Benefits of Keeping Divine Products */}
        <BenefitsSection />

        {/* 5. Process Section (From Our Hands to Your Sacred Space) */}
        <ProcessSection />

        {/* 6. Testimonials (What Our Community Says) */}
        <TestimonialsSection />

        {/* 7. FAQ Section */}
        <FAQSection />
      </main>

      {/* 8. Footer */}
      <Footer />
    </div>
  );
};

export default HomePage;
